import { Stack, Checkbox, Box, Group, Badge } from '@mantine/core'
import React from 'react'
import { useHierarchicalMenu } from 'react-instantsearch'
import { FilterCollapsibleItem } from './FilterCollapsibleItem'

type FilterCollapsibleHierarchicalMenuProps = {
  attributes: string[]
  title: string
  defaultOpened?: boolean
  rootPath?: string
  showParentLevel?: boolean
}

export const FilterCollapsibleHierarchicalMenu = ({
  attributes,
  title,
  defaultOpened,
  rootPath,
  showParentLevel,
}: FilterCollapsibleHierarchicalMenuProps) => {
  const { items, refine, canRefine } = useHierarchicalMenu({
    attributes,
    showParentLevel,
    rootPath,
  })

  if (!canRefine) {
    return null
  }

  const renderItems = (menuItems: any[], level = 0) =>
    menuItems.map((item) => (
      <Box key={item.label} ml={level * 16} mt={level > 0 ? 8 : 0}>
        <Checkbox
          label={
            <Group justify="space-between" w="100%">
              <Box
                style={{
                  flex: 1,
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {item.label}
              </Box>
              <Badge
                variant="light"
                color="var(--mantine-color-piney-lake-1)"
                fw={500}
                style={{
                  whiteSpace: 'nowrap',
                  borderRadius: '20px',
                  paddingLeft: '0.25rem',
                  paddingRight: '0.25rem',
                }}
              >
                {item.count}
              </Badge>
            </Group>
          }
          checked={item.isRefined}
          onChange={() => refine(item.value)}
          styles={{
            label: { cursor: 'pointer' },

            labelWrapper: { width: '100%' },
          }}
        />

        {item.isRefined &&
          item.data &&
          item.data.length > 0 &&
          renderItems(item.data, level + 1)}
      </Box>
    ))

  return (
    <FilterCollapsibleItem title={title} defaultOpened={defaultOpened}>
      <Stack gap="xs" onClick={(e) => e.stopPropagation()}>
        {renderItems(items)}
      </Stack>
    </FilterCollapsibleItem>
  )
}
